<template>
  <div class="col" v-if="selectedCompany">
    <div class="row">
      <div class="col">
        <label for="jobovertimepercentage">Job overtime Percentage access</label>
        <input id="jobovertimepercentage" class="form-control" type="number" v-model="ui.job.overtimePopupPercentage">
      </div>
      <div class="col-2">
        <button class="btn-success btn" @click="savePagesConfig"> Save</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "UISettings",
  props: ['selectedCompany'],
  data() {
    return {
      ui: {
        job: {
          overtimePopupPercentage: 105   // this is in duration of the complete job so 101 is 1 procent overitme
        }
      }
    }
  },
  methods: {
    savePagesConfig() {
      // return this.$FB.collection('companies').doc(this.selectedCompany).update({
      //       config: {
      //         ui: this.ui
      //       }
      //     })
    }
  },
  watch: {
    async selectedCompany() {
      this.ui = this.selectedCompany.config.ui
    }
  },
  created() {
    this.ui = this.selectedCompany.config.ui
    console.log(this.ui)
  }
}
</script>

<style scoped>

</style>